import {
    SAVE_PARAMETERS_STATE,
    SAVE_VARIABLE_STATE,
    VARIABLES_OR_PARAMETER_STATE_UPDATE,
    MODEL_RESET_ORIGINAL_VALUES,
    SET_ACTUAL,
    SET_INITIAL,
    ACTIVE_TAB,
} from './../actions/modelInputReader';

const revenueParametersReducer = (state = {}, { type, rpPayload }) => {
    switch (type) {
        case SAVE_PARAMETERS_STATE:
            return { ...state, rpPayload };
        default:
            return state;
    }
};

const inputVariablesReducer = (state = {}, { type, ivPayload }) => {
    switch (type) {
        case SAVE_VARIABLE_STATE:
            return { ...state, ivPayload };
        default:
            return state;
    }
};

const modelActualReducer = (state = {}, { type, actual }) => {
    switch (type) {
        case SET_ACTUAL:
            return { ...state, actual };
        default:
            return state;
    }
};

const modelInitialReducer = (state = {}, { type, initial }) => {
    switch (type) {
        case SET_INITIAL:
            return { ...state, initial };
        default:
            return state;
    }
};

const parametersVariablesUpdateReducer = (state = {}, { type, status, group }) => {
    switch (type) {
        case VARIABLES_OR_PARAMETER_STATE_UPDATE:
            return { ...state, status, group };
        default:
            return state;
    }
};

const resetOriginalValuesReducer = (state = {}, { type, flag }) => {
    switch (type) {
        case MODEL_RESET_ORIGINAL_VALUES:
            return { ...state, resetOriginalValuesFlag: flag };
        default:
            return state;
    }
};

const setActiveReducer = (state = {}, { type, activeTab }) => {
    switch (type) {
        case ACTIVE_TAB:
            return { ...state, activeTab };
        default:
            return state;
    }
};

export {
    revenueParametersReducer,
    inputVariablesReducer,
    modelActualReducer,
    modelInitialReducer,
    parametersVariablesUpdateReducer,
    resetOriginalValuesReducer,
    setActiveReducer,
};
